import React, { useEffect } from 'react';

export const ValueResizeObserver: React.FC<React.PropsWithChildren> = ({ children }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observedElement = ref.current;
    if (!observedElement) {
      return;
    }

    const observer = new globalThis.ResizeObserver(() => {
      const height = Math.ceil(observedElement.getBoundingClientRect().height);
      const width = Math.ceil(observedElement.getBoundingClientRect().width);

      setTimeout(() => {
        // eslint-disable-next-line no-restricted-syntax
        globalThis.parent.postMessage(
          JSON.stringify({
            method: 'resize',
            height: Math.max(height, 1),
            width: Math.max(width, 1),
          }),
          '*'
        );
      }, 0);
    });
    const registerValueResizeObserver = () => {
      observer.observe(observedElement);
    };

    registerValueResizeObserver();

    return () => {
      observer.unobserve(observedElement);
    };
  }, [ref]);

  return (
    <div ref={ref} data-testid="value-resize-observer">
      {children}
    </div>
  );
};
